export default "__VITE_ASSET__a5126bd5__"